import * as angular from 'angular';
import { Events } from './events';
import { InternetStatus } from './internet-status';

export { Events, InternetStatus };

export const internetStatusModule = angular.module('go.internetStatus', [])
	.factory('internetStatus', InternetStatus)
	.name;
